var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"ion-android-menu hamburger--menu",on:{"click":_vm.onMenuItemClick}})}
var staticRenderFns = []

export { render, staticRenderFns }